import { render, staticRenderFns } from "./PeriodPlan.vue?vue&type=template&id=06ec6ead&"
import script from "./PeriodPlan.vue?vue&type=script&lang=js&"
export * from "./PeriodPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports